import {serializeFormData, syncModelHasFiles} from "./CaseTransformer";
import CandidateApplicationApi from "../api/CandidateApplicationApi";

export const handleSubmitApplicationHelper = async (opportunityId, opportunityUuid, answers) => {
  let answersWithoutFiles = [];
  let screeningQuestionFiles = [];

  for (let i = 0; i < answers.length; i++) {
    let answer = {
      question: answers[i].question,
      type: answers[i].type
    };

    if (answers[i].type === "file" && answers[i].answer?.modelHasFiles?.screening_question) {
      const files = answers[i].answer.modelHasFiles.screening_question;
      answer.answer = answers[i].answer;
      screeningQuestionFiles.push(...files);
    } 

    else if (!(answers[i].answer instanceof File)) {
      answer.answer = answers[i].answer || "";
    }

    answersWithoutFiles.push(answer);
  }

  const formData = serializeFormData({
    opportunity_id: opportunityId,
    screening_questions: answersWithoutFiles,
  }, "post");

  if (screeningQuestionFiles.length > 0) {
    syncModelHasFiles(formData, "screening_question", screeningQuestionFiles);
  }

  for (let i = 0; i < answers.length; i++) {
    if (answers[i].answer && answers[i].answer instanceof File) {
      formData.append(`file_${i}`, answers[i].answer);
    }
  }

  const api = new CandidateApplicationApi();

  await api.createWithFiles(formData);
  toast.success("Your application has been submitted!");
  document.dispatchEvent(new CustomEvent("bd-application-submitted", {detail: {uuid: opportunityUuid}}));
};
